import axios from "axios";
import { formatAmount } from "./format";
import i18n, { normLang } from "@/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("twp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Attach active language so the API can resolve bilingual content (FR/EN).
  // Explicit per-call `lang` params (e.g. /content) are preserved.
  config.params = config.params || {};
  if (config.params.lang === undefined) {
    config.params.lang = normLang(i18n.language || localStorage.getItem("twp_lang"));
  }
  return config;
});

api.interceptors.response.use((r) => r, (err) => {
  if (err.response?.status === 403 && err.response?.data?.detail === "PASSWORD_CHANGE_REQUIRED" && window.location.pathname !== "/change-password") {
    window.location.assign("/change-password");
  }
  return Promise.reject(err);
});

export function apiError(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) => formatAmount(n, true);

export default api;
